import React from 'react'
import { Routes, Route } from 'react-router'
import AppEntry from './entry'
import ForgotPage from './pages/forgot'
import NewPassword from './pages/forgot/newPassword'
import LoginPage from './pages/login'
import { ProtectedRoutes } from './components/ProtectedRoute'
import Users from './pages/users'
import PrivacyPolicy from './pages/privacyPolicy'
import ReleaseNotes from './pages/releaseNotes'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/login' element={<LoginPage />} />
      <Route path='/forgot' element={<ForgotPage />} />
      <Route path='/password-reset' element={<NewPassword />} />
      <Route element={<ProtectedRoutes />}>
        <Route path='/' element={<AppEntry />} />
        <Route path='/users' element={<Users />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/release-notes' element={<ReleaseNotes />} />
      </Route>
    </Routes>
  )
}

export default AppRoutes